export const methods = Object.freeze({
  METHOD_GOOGLE: 'GOOGLE',
  METHOD_OUTLOOK: 'OUTLOOK',
});
